import { Component } from "react";


class Card extends Component {

    render() {
        return (

            <div className="col my-3" style={ { color: 'white' }} >
             
                <div className="card bg-black shadow-lg p-3 mb-5 rounded"  >
                <img src={this.props.card.immagine} className="card-img-top" alt="..."/>
                    <div className="card-body">
                        <h5 className="card-title">{this.props.card.nome}</h5>
                    </div>
                </div>
            </div>

        );
    }

}

export default Card;